var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1455_14684",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1455_14684",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAEAUlEQVR4nO2dy6tNURzHP143j4soikIojxEzkWKglBFSChMxIAP+ARMpGRkwUBiIGDAwIGUiE48YKCkDlDzSlWfe9+garHuy7rr73mvvfc7e37XO71Or9m+ds9Zee3322nvts1f3Qn76Ik0NYEeB45Wn7o41KQF1d6pJCai7Q01KQHhw6iQvJRUhyUiJXUhvRry1tta1gNiFbGGwlKhHSuxCIDEpKQiBhKSkIgQSkZKSEEhASmpCIHIpKQqBiKWkKgQilZKyEIhQSupCIDIpnSAEIpLSKUIgEimdJAQikNJpQkBcSicKAWEpnSoERKV0shAQlNLpQkBMiglxyEgxIf+QkGJCBlK7lNiFVJUKSRlV8ADL1lEldZ40DWBcngImpP3k6p/R7WqFUYyxdTegAqoewaVGpI0QMUyIGCZEDBMihgkRw4SIYULEMCFimBAxTIgYJkQMEyKGCRHDhIhhQsQwIWLUKWQXcAt4C3zFvdj5CbwErgG7gUlDlD0LPAI+4N5b/wHeA7eBI8DCEfbd0192uLSn2GFVT6tWnZzJqCtMT4HlGWW/jVCuARwCxgyx73DZTlY6UPC4SvWP2iXrRxAvBK4Ds0Yo9wk3SpqMAQ4CR1vXNF3aMUIawMT+/KXAzWAfx4Oy/gg51583DtiOu9z4ZTdl7NsfITeBdRlpbsHjqnzdWjuE9AafTQU+e5/3MHCxQpaQJisY2OEPGbzQwf/8YoljyCKpS1aTz8BlL54BzPvPsveA8168DFjTona1HVUhAM+CeHqOsmeDeG3JtlSGspCJQfwtR9m7wG8vXl2+OdWgLGSJt92Lez75X34CL7x4UUtaVAGqQuYCG7z4DvA9Zx1vvO1ppVtUEYpLSVfiZmATvLxjBerxL3HdQBcDL2NNNuOmyiHzcZOLSlERMhZ4jZMQns0XgCsF6gynnEM9tXf1p5BaVvWrCAGYHcR9wClgX8H6ur3tXwz+FUASJSFN3gE3gBO42VJRpnrbH4f53lVgf0b+lxL7LoyKkAYwE3cm5715D8UCb7tnmO99BZ63aJ+lURECw5/FeZkDTPHi+y2su62oTnvLsj6Ib9fSigKkKmSnt93A3ZOiIEUh24BVXnwZeFVTW3KTkpAu3GvX017ed+BwPc0phtJNvSgbgSe455jJXn4fsBd4XEejipKCkG5gcZD3BbdI4lL1zSlHrEJ+MPjn+d/AA9yKlZNk/z4lT8x/yWE87qXVeNzDXXNJUN2U6p+YhahSqn9SmmUlgQkRw4SIYULEMCFimBAxTIgYJkQMEyKGCRHDhIhhQsQwIWKYEDFMiBgmRAwTIoYJEcOEiGFCxDAhYpgQMVqxUK7u/2CTFDZCxDAhYpgQMf4C4lnsW5u6r3MAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.44e3fd5620fbad0016a9417d9535697e.svg";
export { ForwardRef as ReactComponent };